jQuery( document ).ready( function ( $ ) {

	$(".subsection-js").click(function(e){

		const isActive = $(this).hasClass("active");

		$(".subsection-js").removeClass("active");

		if (!isActive) {
			$(this).addClass("active");
		}
	});
})